import { EnvironmentTypes } from './environmentTypes';

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 63 : 115,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
